import React from 'react';

import Main from '../containers/main/Main';
import About from '../containers/about/About';
import Cilj from '../containers/Cilj/Cilj';
import Misija from '../containers/Misija/Misija';
import Contact from '../containers/Contact/Contact';
import Footer from '../containers/Footer/Footer';
import Partners from '../containers/Partners/Partners';

const Home = () => {
  return (
    <>
      <Main />
      <div className="home-band">
        <About />
        <Cilj />
        <Misija />
      </div>
      <Partners />
      <Contact />
      <Footer />
    </>
  );
};

export default Home;
